import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  // 获取证据材料
  getFiles: {
    url: '/client/files',
    method: 'post'
  },
  // 案件详情
  caseDetail: {
    url: '/case/detail',
    method: 'get'
  }
};
export default withHttp(apis, baseURL);